// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".chat[data-v-03ce3531],.favoriten[data-v-03ce3531],.search[data-v-03ce3531]{transition:filter .3s ease-in-out}.chat.dark[data-v-03ce3531],.favoriten.dark[data-v-03ce3531],.search.dark[data-v-03ce3531]{filter:contrast(0) brightness(2)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
